/* Leaf Rain Animation Handler */

class LeafRain {
  constructor() {
    this.container = null;
    this.leafCount = 25; // Number of leaves to create
    this.duration = 5000; // 5 seconds for slower fall
    this.leafColors = [
      { fill: '#03604E' },
      { fill: '#68A095' },
      { fill: '#42887A' },
      { fill: '#106857' },
      { fill: '#024D3E' }
    ];
  }

  init() {
    if (!this.container) {
      this.container = document.createElement('div');
      this.container.className = 'leaf-rain-container';
      document.body.appendChild(this.container);
    }
  }

  getRandomLeafSVG() {
    const color = this.leafColors[Math.floor(Math.random() * this.leafColors.length)];
    return `
      <svg aria-hidden="true" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg">
        <path fill="${color.fill}" d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
      </svg>
    `;
  }

  createLeaf() {
    const leaf = document.createElement('div');
    const sizes = ['small', 'medium', 'large'];
    const size = sizes[Math.floor(Math.random() * sizes.length)];

    leaf.className = `leaf ${size}`;
    leaf.innerHTML = this.getRandomLeafSVG();

    // Random horizontal starting position
    const startX = Math.random() * 100;
    leaf.style.left = `${startX}%`;

    // Random animation duration (4-7 seconds for slower fall)
    const fallDuration = 4 + Math.random() * 3;
    leaf.style.animationDuration = `${fallDuration}s`;

    // Random delay for staggered effect
    const delay = Math.random() * 4;
    leaf.style.animationDelay = `${delay}s`;

    // Randomly choose animation pattern
    const animations = ['fall', 'fall-sway-left', 'fall-sway-right'];
    const selectedAnimation = animations[Math.floor(Math.random() * animations.length)];
    leaf.style.animationName = selectedAnimation;
    leaf.style.animationFillMode = 'forwards';

    return leaf;
  }

  start() {
    // Check for reduced motion preference
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      console.log('Leaf rain: Reduced motion detected, skipping animation');
      return;
    }

    this.init();
    console.log('Leaf rain: Container created', this.container);

    // Create and add leaves
    const leaves = [];
    for (let i = 0; i < this.leafCount; i++) {
      const leaf = this.createLeaf();
      leaves.push(leaf);
      this.container.appendChild(leaf);
    }

    console.log(`Leaf rain: Created ${leaves.length} leaves`, leaves);

    // Remove container after animation completes (longest possible duration is 7s + 1s delay)
    setTimeout(() => {
      leaves.forEach(leaf => leaf.remove());
      console.log('Leaf rain: Animation complete, leaves removed');
    }, 16000); // 8 seconds to ensure all leaves complete their animation
  }

  // Public method to trigger the animation
  static trigger() {
    const leafRain = new LeafRain();
    leafRain.start();
  }
}

// Make it globally available
window.LeafRain = LeafRain;

// Free Shipping Threshold Manager
class FreeShippingNotification {
  constructor() {
    this.threshold = 3000; // 30 euros in cents
    this.hasTriggered = false; // Only trigger once per session
    this.previousTotal = 0;
  }

  checkThreshold(cartData) {
    // Cart total is in cents
    const currentTotal = this.previousTotal + cartData.final_price

    console.log('Free shipping check:', {
      previousTotal: this.previousTotal,
      currentTotal: currentTotal,
      threshold: this.threshold,
      hasTriggered: this.hasTriggered
    });

    // Check if we crossed the threshold (from below to above)
    if (!this.hasTriggered && this.previousTotal < this.threshold && currentTotal >= this.threshold) {
      this.hasTriggered = true;
      this.showNotification();
      LeafRain.trigger();
    }

    this.previousTotal = currentTotal;
  }

  showNotification() {
    // Create a custom notification similar to cart-notification
    const notification = document.createElement('div');
    notification.className = 'free-shipping-notification';
    notification.innerHTML = `
      <div class="free-shipping-notification__content">
        <div class="free-shipping-notification__header">
          <svg class="free-shipping-notification__icon" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
          </svg>
          <h2 class="free-shipping-notification__heading">Free Shipping Unlocked!</h2>
          <button type="button" class="free-shipping-notification__close" aria-label="Close">
            <svg viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
            </svg>
          </button>
        </div>
        <p class="free-shipping-notification__message">Congratulations! You've qualified for free shipping on your order.</p>
      </div>
    `;

    document.body.appendChild(notification);

    // Add styles dynamically if not already added
    if (!document.getElementById('free-shipping-notification-styles')) {
      const style = document.createElement('style');
      style.id = 'free-shipping-notification-styles';
      style.textContent = `
        .free-shipping-notification {
          position: fixed;
          top: 20px;
          right: 20px;
          z-index: 10000;
          max-width: 400px;
          background: rgb(var(--color-button));
          color: rgb(var(--color-button-text));
          padding: 20px;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(var(--color-shadow), 0.3);
          animation: slideInRight 0.4s ease-out;
          font-family: var(--font-body-family);
        }

        .free-shipping-notification__content {
          position: relative;
        }

        .free-shipping-notification__header {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 8px;
        }

        .free-shipping-notification__icon {
          width: 24px;
          height: 24px;
          flex-shrink: 0;
          fill: #81C784;
        }

        .free-shipping-notification__heading {
          margin: 0;
          font-size: 18px;
          font-weight: var(--font-body-weight-bold);
          flex: 1;
          color: rgb(var(--color-button-text));
        }

        .free-shipping-notification__close {
          background: none;
          border: none;
          color: rgb(var(--color-button-text));
          cursor: pointer;
          padding: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0.8;
          transition: opacity 0.2s;
        }

        .free-shipping-notification__close:hover {
          opacity: 1;
        }

        .free-shipping-notification__close svg {
          width: 20px;
          height: 20px;
        }

        .free-shipping-notification__message {
          margin: 0;
          font-size: 14px;
          line-height: 1.5;
          padding-left: 36px;
          color: rgb(var(--color-button-text));
        }

        @keyframes slideInRight {
          from {
            transform: translateX(400px);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }

        @keyframes slideOutRight {
          from {
            transform: translateX(0);
            opacity: 1;
          }
          to {
            transform: translateX(400px);
            opacity: 0;
          }
        }

        .free-shipping-notification.closing {
          animation: slideOutRight 0.3s ease-out forwards;
        }

        @media (max-width: 768px) {
          .free-shipping-notification {
            top: 10px;
            right: 10px;
            left: 10px;
            max-width: none;
          }
        }
      `;
      document.head.appendChild(style);
    }

    // Auto-close after 6 seconds
    setTimeout(() => {
      this.closeNotification(notification);
    }, 6000);

    // Close button handler
    const closeButton = notification.querySelector('.free-shipping-notification__close');
    closeButton.addEventListener('click', () => {
      this.closeNotification(notification);
    });
  }

  closeNotification(notification) {
    notification.classList.add('closing');
    setTimeout(() => {
      notification.remove();
    }, 300);
  }
}

// Initialize the free shipping notification manager
const freeShippingManager = new FreeShippingNotification();

// Wait for DOM to be ready and subscribe to cart update events
document.addEventListener('DOMContentLoaded', function() {
  // Listen for add-to-cart events using the global PUB_SUB_EVENTS
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      // Check if cart crossed the free shipping threshold
      if (event && event.cartData) {
        freeShippingManager.checkThreshold(event.cartData);
      }
    });
  }
});
